import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { UserCircle, Sparkles, MessageCircle, Fingerprint } from 'lucide-react';
import { MrAvatar } from '../components/MrAvatar';
export function BrandPersona() {
  return <FeaturePageLayout customContent={<div className="flex justify-center -mt-8 mb-16 relative z-10" data-id="element-1364">
          <MrAvatar size={240} expression="winking" accessory="sunglasses" data-id="element-1365" />
        </div>} hero={{
    badge: 'Step 4 of 7',
    h1: <>
            Create Brand{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-1366">
              Persona
            </span>
          </>,
    subtitle: 'Using the ingested data, we craft a unique, consistent brand voice. Your AI agents will sound exactly like your best employees.'
  }} problem={{
    subtitle: 'The Identity Problem',
    cards: [{
      icon: <MessageCircle className="w-6 h-6 text-teal" data-id="element-1367" />,
      title: 'Robotic Responses',
      desc: 'Out-of-the-box AI sounds generic, robotic, and lacks the nuance of your actual brand voice.'
    }, {
      icon: <UserCircle className="w-6 h-6 text-purple" data-id="element-1368" />,
      title: 'Inconsistent Tone',
      desc: 'Different departments and agents often communicate with wildly different tones, confusing customers.'
    }, {
      icon: <Fingerprint className="w-6 h-6 text-blue-400" data-id="element-1369" />,
      title: 'Lost Brand Identity',
      desc: 'When automating, companies often sacrifice their unique personality for the sake of efficiency.'
    }]
  }} solution={{
    badge: 'The Persona',
    title: 'Your Digital DNA',
    desc: 'We synthesize your uploaded data to create a master persona that dictates exactly how your AI behaves, speaks, and responds.',
    features: [{
      icon: <Sparkles className="w-6 h-6 text-teal" data-id="element-1370" />,
      title: 'Voice Matching',
      desc: 'We analyze your best historical interactions to replicate your ideal tone and vocabulary.'
    }, {
      icon: <Fingerprint className="w-6 h-6 text-purple" data-id="element-1371" />,
      title: 'Core Values Integration',
      desc: "Your brand's core values and operational guidelines are hardcoded into the persona's decision-making process."
    }]
  }} data-id="element-1363" />;
}